import { PlayerStore } from '../../store'

export default {
  name: 'PlayerStoreProvider',
  provide () {
    return {
      playerStore: this.store
    }
  },
  props: {
    modules: {
      type: Array,
      default: () => ([])
    },
    holderId: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      store: new PlayerStore({}, this.holderId)
    }
  },
  watch: {
    modules: {
      immediate: true,
      handler (val) {
        if (!val.length) {
          return
        }
        const init = {
          state: {},
          class: PlayerStore
        }

        const store = this.modules
          .reduce((accumulator, module) => {
            const {state, mixin} = module()
            return {
              state: Object.assign(accumulator.state, state),
              class: mixin(accumulator.class)
            }
          }, init)

        this.store = new store.class(store.state, this.holderId)
      }
    }
  },
  render() {
    return this.$scopedSlots.default()
  }
}
